<template>
  <div class="wrapper">
    <div class="con" id="loginL" v-if="host !== 'o2o.hscwhn.com' ||
      $route.query.login === 'wangxuan' ||
      isMobile()
    ">
      <div class="item title">花生宠物医院管理系统</div>
      <div class="item">
        <div class="input_content">
          <img src="../assets/img/logName.png" width="16" height="16" alt />
          <input class="input userinput" type name id value v-model="user" placeholder="请输入用户名" />

        </div>
      </div>
      <div class="item">
        <div class="input_content">
          <img src="../assets/img/logPwd.png" width="16" height="16" alt />
          <input class="input pswinput" type="password" name id value v-model="pwd" @keyup.enter="submit"
            placeholder="请输入密码" />
        </div>
      </div>
      <div class="item btn">
        <div class="button" @click="submit">
          <span>登录</span>
        </div>
      </div>
    </div>
    <!-- <div class="con" id="loginR" v-if="!isMobile()">
          <div id="login_container"></div>
        </div> -->

    <el-tabs v-if="!isMobile()">
      <el-tab-pane>
        <div class="qrcode">
          <div ref="wx_qrcode" id="wx_qrcode"></div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
let Base64 = require("js-base64").Base64;
import * as ww from "@wecom/jssdk";
export default {
  data() {
    return {
      user: "",
      pwd: "",
      authCode: "", //1
      wwLogin: null, //1记录组件的实例
      appId: "ww8833d175b32ca6b0",
      host: window.location.host,
      menuListRoute: [
        {
          title: "工作台",
          path: "/mendian",
          code: "mendian",
          src: require("../assets/img/leftNav/member.png"),
          children: {
            shouyin: {
              title: "工作台",
              flag: true,
              code: "shouyin",
            },
            addUser: {
              title: "新增顾客",
              flag: true,
              code: "addUser",
            },
            deletePet: {
              title: "洗美卡退款",
              flag: true,
              code: "deletePet",
            },
            refund: {
              title: "清空账户",
              flag: true,
              code: "refund",
            },
            dianshang: {
              title: "电商",
              flag: true,
              code: "dianshang",
            },
            gengxin: {
              title: "历史更新日志",
              flag: true,
              code: "gengxin",
            },
            doctor: {
              title: "活体商城显示挂号",
              flag: true,
              code: "doctor",
            },
            shops: {
              title: "活体商城切换门店",
              flag: true,
              code: "shops",
            },
          },
        },
        {
          title: "门店业务",
          code: "yewu",
          src: require("../assets/img/leftNav/mendian.png"),
          children: [
            {
              path: "/ximei",
              title: "洗美管理",
              code: "ximei",
              menu_type: 2,
            },
            {
              path: "/jiyang",
              title: "寄养管理",
              code: "jiyang",
              menu_type: 2,
            },
            {
              path: "/yiliaoxin",
              title: "医疗管理",
              code: "yiliaoxin",
              menu_type: 2,
              children: {
                platform: {
                  title: "医疗工作台",
                  flag: true,
                  code: "platform",
                  menu_type: 3,
                },
                tagList: {
                  title: "医疗标签",
                  flag: true,
                  code: "tagList",
                  menu_type: 3,
                },
                tabItem1: {
                  title: "挂号",
                  flag: true,
                  code: "tabItem1",
                  menu_type: 3,
                },
                tabItem2: {
                  title: "接诊",
                  flag: true,
                  code: "tabItem2",
                  menu_type: 3,
                },
                tabItem3: {
                  title: "病例",
                  flag: true,
                  code: "tabItem3",
                  menu_type: 3,
                },
                tabItem4: {
                  title: "疫苗驱虫",
                  flag: true,
                  code: "tabItem4",
                  menu_type: 3,
                },
                tabItem5: {
                  title: "医疗服务",
                  flag: true,
                  code: "tabItem5",
                  menu_type: 3,
                },
                tabItem6: {
                  title: "住院",
                  flag: true,
                  code: "tabItem6",
                  menu_type: 3,
                },
                tabItem7: {
                  title: "药房",
                  flag: true,
                  code: "tabItem7",
                  menu_type: 3,
                },
                editbingli: {
                  title: "病例编辑按钮",
                  flag: true,
                  code: "editbingli",
                  menu_type: 3,
                },
                delbingli: {
                  title: "病例删除",
                  flag: true,
                  code: "delbingli",
                  menu_type: 3,
                },
                jiezhen: {
                  title: "列表接诊",
                  flag: true,
                  code: "jiezhen",
                  menu_type: 3,
                },
                editjiezhen: {
                  title: "接诊编辑",
                  flag: true,
                  code: "editjiezhen",
                  menu_type: 3,
                },
                del: {
                  title: "接诊删除",
                  flag: true,
                  code: "del",
                  menu_type: 3,
                },
                editquchong: {
                  title: "驱虫编辑",
                  flag: true,
                  code: "editquchong",
                  menu_type: 3,
                },
                delquchong: {
                  title: "驱虫删除",
                  flag: true,
                  code: "delquchong",
                  menu_type: 3,
                },
                edityiliao: {
                  title: "医疗编辑",
                  flag: true,
                  code: "edityiliao",
                  menu_type: 3,
                },
                delyiliao: {
                  title: "医疗删除",
                  flag: true,
                  code: "delyiliao",
                  menu_type: 3,
                },
                editzhuyuan: {
                  title: "住院编辑",
                  flag: true,
                  code: "editzhuyuan",
                  menu_type: 3,
                },

                delzhuyuan: {
                  title: "住院删除",
                  flag: true,
                  code: "delzhuyuan",
                  menu_type: 3,
                },
                editDate: {
                  title: "疫苗驱虫编辑实施日期",
                  flag: true,
                  code: "editDate",
                  menu_type: 3,
                },
              },
            },
            {
              path: "/yuyue",
              title: "预约管理",
              code: "yuyue",
              children: {
                yuyuePaiBan: {
                  title: "预约排班",
                  flag: true,
                  code: "yuyuePaiBan",
                  menu_type: 3,
                },
                yuyueShop: {
                  title: "门店预约",
                  flag: true,
                  code: "yuyueShop",
                  menu_type: 3,
                },
                petShuttle: {
                  title: "宠物接送",
                  flag: true,
                  code: "petShuttle",
                  menu_type: 3,
                },
              },
            },
          ],
        },
        {
          title: "会员管理",
          src: require("../assets/img/leftNav/huiyuan.png"),
          path: "/huiyuan",
          code: "huiyuan",
          children: {
            giveCoupon: {
              title: "赠送优惠券",
              flag: true,
              code: "giveCoupon",
            },
            exportUser: {
              title: "导出顾客列表",
              flag: true,
              code: "exportUser",
            },
            delpet: {
              title: "删除宠物",
              flag: true,
              code: "delpet",
            },
            see: {
              title: "宠物信息查看",
              flag: true,
              code: "see",
            },
          },
        },
        {
          title: "订单管理",
          src: require("../assets/img/leftNav/dingdan.png"),
          code: "dingdan",
          children: [
            {
              path: "/dingdan",
              title: "消费订单",
              code: "saleOrder",
              children: {
                changeStaff: {
                  title: "修改销售人员",
                  flag: true,
                  code: "changeStaff",
                },
                changezhifu: {
                  title: "修改支付方式",
                  flag: true,
                  code: "changezhifu",
                },
                tuikuan: {
                  title: "退款",
                  flag: true,
                  code: "tuikuan",
                },
                jiyangTuikuan: {
                  title: "寄养退款",
                  flag: true,
                  code: "jiyangTuikuan",
                },
                tuihuo: {
                  title: "退货",
                  flag: true,
                  code: "tuihuo",
                },
                addedit: {
                  title: "添加删除发票",
                  flag: true,
                  code: "addedit",
                },
              },
            },
            {
              path: "/rechargeOrder",
              title: "充值订单",
              code: "rechargeOrder",
              children: {
                tuikuan: {
                  title: "退款",
                  flag: true,
                  code: "tuikuan",
                },
                changeStaff: {
                  title: "修改销售人员",
                  flag: true,
                  code: "changeStaff",
                },
                jiesuan: {
                  title: "结算",
                  flag: true,
                  code: "jiesuan",
                },
                zengsong: {
                  title: "赠送",
                  flag: true,
                  code: "zengsong",
                },
                canle: {
                  title: "取消",
                  flag: true,
                  code: "canle",
                },
              },
            },
            {
              path: "/returnOrder",
              title: "退换货",
              code: "returnOrder",
              children: {
                cancel: {
                  title: "取消",
                  flag: true,
                  code: "cancel",
                },
                settle: {
                  title: "结算",
                  flag: true,
                  code: "settle",
                },
              },
            },
            {
              path: "/arrearsOrder",
              title: "欠宠记录",
              code: "arrearsOrder",
              children: {
                sendback: {
                  title: "退宠",
                  flag: true,
                  code: "sendback",
                },
                exchange: {
                  title: "换宠",
                  flag: true,
                  code: "exchange",
                },
                cancel: {
                  title: "取消",
                  flag: true,
                  code: "cancel",
                },
              },
            },
            {
              path: "/onlineOrder",
              title: "线上订单",
              code: "onlineOrder",
            },
            {
              path: "/onlineReturn",
              title: "线上退货",
              code: "onlineReturn",
              children: {
                cancel: {
                  title: "取消",
                  flag: true,
                  code: "cancel",
                },
              },
            },
          ],
        },
        {
          title: "活体管理",
          code: "huoti",
          src: require("../assets/img/leftNav/huoti.png"),
          children: [
            {
              path: "/huotiHouse",
              title: "宠物房间",
              code: "pethouse",
              children: {
                pethouse: {
                  title: "宠物房间",
                  flag: true,
                  code: "pethouse",
                  menu_type: 3,
                },
                houseLog: {
                  title: "房间日志",
                  flag: true,
                  code: "houseLog",
                  menu_type: 3,
                },

                shop: {
                  title: "门店切换",
                  flag: true,
                  code: "shop",
                  menu_type: 3,
                },
                addcage: {
                  title: "创建房间",
                  flag: true,
                  code: "addcage",
                  menu_type: 3,
                },
                editcage: {
                  title: "房间详情编辑",
                  flag: true,
                  code: "editcage",
                  menu_type: 3,
                },
                delcage: {
                  title: "房间详情删除",
                  flag: true,
                  code: "delcage",
                  menu_type: 3,
                },
                person: {
                  title: "编辑添加宠物负责人",
                  flag: true,
                  code: "person",
                },
              },
            },
            {
              path: "/huotiZongcang",
              title: "宠物列表",
              code: "zongcang",
              children: {
                addPet: {
                  title: "添加宠物",
                  flag: true,
                  code: "addPet",
                },
                huotiStock: {
                  title: "活体库存",
                  flag: true,
                  code: "huotiStock",
                },
                delpet: {
                  title: "删除宠物",
                  flag: true,
                  code: "delpet",
                },
                yimiao: {
                  title: "宠物疫苗修改",
                  flag: true,
                  code: "yimiao",
                },
                message: {
                  title: "宠物基本信息",
                  flag: true,
                  code: "message",
                },
                editpet: {
                  title: "编辑宠物",
                  flag: true,
                  code: "editpet",
                },
                price: {
                  title: "宠物特价修改",
                  flag: true,
                  code: "price",
                },
                stockalert: {
                  title: "库存预警",
                  flag: true,
                  code: "stockalert",
                },
                adddeath: {
                  title: "添加死亡",
                  flag: true,
                  code: "adddeath",
                },
                export: {
                  title: "数据导出",
                  flag: true,
                  code: "export",
                },
                delrecord: {
                  title: "删除疫苗记录",
                  flag: true,
                  code: "delrecord",
                },
              },
            },
            {
              path: "/huotiMendian",
              title: "门店宠物",
              code: "Mendian",
            },
            {
              path: "/huotiCharge",
              title: "活体负责人",
              code: "charge",
              children: {
                charger: {
                  title: "活体负责人",
                  flag: true,
                  code: "charger",
                  menu_type: 3,
                },
                royalty: {
                  title: "负责人提成",
                  flag: true,
                  code: "royalty",
                  menu_type: 3,
                },

                royaltyedit: {
                  title: "提成编辑",
                  flag: true,
                  code: "royaltyedit",
                  menu_type: 3,
                },
                royaltydel: {
                  title: "提成删除",
                  flag: true,
                  code: "royaltydel",
                  menu_type: 3,
                },
                derive: {
                  title: "数据导出",
                  flag: true,
                  code: "derive",
                  menu_type: 3,
                },
                add: {
                  title: "提成添加",
                  flag: true,
                  code: "add",
                  menu_type: 3,
                },
              },
            },
          ],
        },
        {
          title: "系统配置",
          code: "xitong",
          src: require("../assets/img/leftNav/xiaochengxu.png"),
          children: [
            {
              path: "/huodong",
              title: "活动配置",
              code: "huodong",
              children: {
                huodongList: {
                  title: "活动",
                  flag: true,
                  code: "huodongList",
                },
                cardList: {
                  title: "现金卡活动",
                  flag: true,
                  code: "cardList",
                },
              },
            },
            {
              path: "/goods",
              title: "商品配置",
              code: "goods",
            },
            {
              path: "/oa",
              title: "消息配置",
              code: "message",
              children: {
                messageList: {
                  title: "app消息配置",
                  flag: true,
                  code: "messageList",
                },
                weixinList: {
                  title: "企业微信消息配置",
                  flag: true,
                  code: "weixinList",
                },
                publicList: {
                  title: "公众号消息配置",
                  flag: true,
                  code: "publicList",
                },
              },
            },
            {
              path: "/ximeiyuyue",
              title: "洗美项目",
              code: "ximeiyuyue",
            },
            {
              path: "/housePeizhi",
              title: "宠物房设置",
              code: "housepeizhi",
              children: {
                addCage: {
                  title: "创建房间",
                  flag: true,
                  code: "addCage",
                },
                editCage: {
                  title: "编辑",
                  flag: true,
                  code: "editCage",
                },
                delCage: {
                  title: "删除",
                  flag: true,
                  code: "delCage",
                },
              },
            },
            {
              path: "/signature",
              title: "印章管理",
              code: "signature",
            },
            {
              path: "/brand",
              title: "品牌管理",
              code: "brand",
            },
            {
              path: "/gongyingshang",
              title: "供应商管理",
              code: "gongyingshang",
            },
            {
              path: "/template",
              title: "合同模版",
              code: "template",
            },
            {
              path: "/version",
              title: "版本更新",
              code: "version",
            },
          ],
        },
        {
          title: "员工管理",
          code: "staff",
          src: require("../assets/img/leftNav/staff.png"),
          children: [
            {
              path: "/controlStaff",
              title: "员工列表",
              code: "controlStaff",
              children: {
                add: {
                  title: "添加",
                  flag: true,
                  code: "add",
                },
                edit: {
                  title: "编辑",
                  flag: true,
                  code: "edit",
                },
                del: {
                  title: "删除",
                  flag: true,
                  code: "del",
                },
                allot: {
                  title: "分配权限",
                  flag: true,
                  code: "allot",
                },
              },
            },
            {
              path: "/controlRight",
              title: "系统菜单",
              code: "controlRight",
              children: {
                add: {
                  title: "新增",
                  flag: true,
                  code: "add",
                },
                edit: {
                  title: "编辑",
                  flag: true,
                  code: "edit",
                },
                del: {
                  title: "删除",
                  flag: true,
                  code: "del",
                },
                addone: {
                  title: "新增一级菜单",
                  flag: true,
                  code: "addone",
                },
              },
            },
            {
              path: "/controlRole",
              title: "角色管理",
              code: "controlRole",
              children: {
                add: {
                  title: "新增",
                  flag: true,
                  code: "add",
                },
                edit: {
                  title: "编辑",
                  flag: true,
                  code: "edit",
                },
                status: {
                  title: "状态",
                  flag: true,
                  code: "status",
                },
                allot: {
                  title: "分配权限",
                  flag: true,
                  code: "allot",
                },
                del: {
                  title: "删除",
                  flag: true,
                  code: "del",
                },
              },
            },
          ],
        },
        {
          title: "仓储管理",
          code: "cangku",
          src: require("../assets/img/leftNav/cangku.png"),
          children: [
            {
              path: "/caigouMendian",
              title: "门店采购",
              code: "caigouMendian",
              children: {
                caigou: {
                  title: "采购列表",
                  flag: true,
                  code: "caigou",
                },
                yanshou: {
                  title: "验收列表",
                  flag: true,
                  code: "yanshou",
                },
                apply: {
                  title: "申请采购",
                  flag: true,
                  code: "apply",
                },
                oneKey: {
                  title: "一键验收",
                  flag: true,
                  code: "oneKey",
                },
              },
            },
            {
              path: "/caigou",
              title: "总仓采购",
              code: "shenpiList",
              children: {
                apply: {
                  title: "审批",
                  flag: true,
                  code: "apply",
                },
                caigou: {
                  title: "采购",
                  flag: true,
                  code: "caigou",
                },
                shenpiList: {
                  title: "商品审批",
                  flag: true,
                  code: "shenpiList",
                },
                caigouList: {
                  title: "商品采购",
                  flag: true,
                  code: "caigouList",
                },
              },
            },
            {
              path: "/yujing",
              title: "库存预警",
              code: "yujing",
              children: {
                add: {
                  title: "发起采购",
                  flag: true,
                  code: "add",
                },
                educe: {
                  title: "导出",
                  flag: true,
                  code: "educe",
                },
              },
            },
            {
              path: "/tiaoma",
              title: "条码追踪",
              code: "tiaoma",
              children: {
                edit: {
                  title: "编辑",
                  flag: true,
                  code: "edit",
                },
                split: {
                  title: "拆分",
                  flag: true,
                  code: "split",
                },
              },
            },
            {
              path: "/wuliao",
              title: "门店资产",
              code: "wuliao",
              children: {
                checkList: {
                  title: "资产验收",
                  flag: true,
                  code: "checkList",
                },
                wuliaoList: {
                  title: "门店资产",
                  flag: true,
                  code: "wuliaoList",
                },
                inventoryList: {
                  title: "资产库存",
                  flag: true,
                  code: "inventoryList",
                },

                addzichan: {
                  title: "新建资产",
                  flag: true,
                  code: "addzichan",
                },
                editzichan: {
                  title: "资产编辑",
                  flag: true,
                  code: "editzichan",
                },
                delzichan: {
                  title: "资产删除",
                  flag: true,
                  code: "delzichan",
                },
                addfahuo: {
                  title: "新建发货单",
                  flag: true,
                  code: "addfahuo",
                },
                diaobo: {
                  title: "资产调拨",
                  flag: true,
                  code: "diaobo",
                },
                jiebang: {
                  title: "全部解绑",
                  flag: true,
                  code: "jiebang",
                },
                allot: {
                  title: "分配员工",
                  flag: true,
                  code: "allot",
                },
                staffzichan: {
                  title: "员工资产",
                  flag: true,
                  code: "staffzichan",
                },
              },
            },
            {
              path: "/kucun",
              title: "库存列表",
              code: "kucun",
              children: {
                educe: {
                  title: "导出表格",
                  flag: true,
                  code: "educe",
                },
              },
            },
            {
              path: "/chuku",
              title: "出库记录",
              code: "chuku",
              children: {
                add: {
                  title: "新建出库",
                  flag: true,
                  code: "add",
                },
                split: {
                  title: "条码拆分",
                  flag: true,
                  code: "split",
                },
                baofei: {
                  title: "报废出库",
                  flag: true,
                  code: "baofei",
                },
              },
            },
            {
              path: "/ruku",
              title: "入库记录",
              code: "ruku",
            },
            {
              path: "/guoqi",
              title: "过期预警",
              code: "guoqi",
              children: {
                educe: {
                  title: "导出",
                  flag: true,
                  code: "educe",
                },
              },
            },
          ],
        },
        {
          title: "仓储管理(新)",
          code: "cangku2",
          src: require('../assets/img/leftNav/cangku.png'),
          children: [
            {
              path: "/caigouMendianNew",
              title: "门店采购",
              code: "caigouMendian",
              children: {
                caigou: {
                  title: "采购列表",
                  flag: true,
                  code: "caigou",
                },
                yanshou: {
                  title: "验收列表",
                  flag: true,
                  code: "yanshou",
                },
                apply: {
                  title: "申请采购",
                  flag: true,
                  code: "apply",
                }
              },
            },
            {
              path: "/caigouNew",
              title: "总仓采购",
              code: "shenpiList",
              children: {
                apply: {
                  title: "审批",
                  flag: true,
                  code: "apply",
                },
                caigou: {
                  title: "采购",
                  flag: true,
                  code: "caigou",
                },
                shenpiList: {
                  title: "商品审批",
                  flag: true,
                  code: "shenpiList",
                },
                caigouList: {
                  title: "商品采购",
                  flag: true,
                  code: "caigouList",
                },


              },
            }, {
              path: "/pandian",
              title: "库存盘点",
              code: "inventory"

            },
            {
              path: "/yujingNew",
              title: "临期商品",
              code: "yujing",
              children: {
                add: {
                  title: "新建",
                  flag: true,
                  code: "add",
                },
                educe: {
                  title: "打印条码",
                  flag: true,
                  code: "educe",
                }
              },

            }
            ,
            {
              path: "/wuliao",
              title: "门店资产",
              code: "wuliao",
              children: {
                checkList: {
                  title: "资产验收",
                  flag: true,
                  code: "checkList",
                },
                wuliaoList: {
                  title: "门店资产",
                  flag: true,
                  code: "wuliaoList",
                },
                inventoryList: {
                  title: "资产库存",
                  flag: true,
                  code: "inventoryList",
                },

                addzichan: {
                  title: "新建资产",
                  flag: true,
                  code: "addzichan",
                },
                editzichan: {
                  title: "资产编辑",
                  flag: true,
                  code: "editzichan",
                },
                delzichan: {
                  title: "资产删除",
                  flag: true,
                  code: "delzichan",
                },
                addfahuo: {
                  title: "新建发货单",
                  flag: true,
                  code: "addfahuo",
                },
                diaobo: {
                  title: "资产调拨",
                  flag: true,
                  code: "diaobo",
                },
                jiebang: {
                  title: "全部解绑",
                  flag: true,
                  code: "jiebang",
                },
                allot: {
                  title: "分配员工",
                  flag: true,
                  code: "allot",
                },
                staffzichan: {
                  title: "员工资产",
                  flag: true,
                  code: "staffzichan",
                },
              },

            },
            {
              path: "/kucunNew",
              title: "库存列表",
              code: "kucun",
              children: {
                educe: {
                  title: "编辑",
                  flag: true,
                  code: "educe",
                }
              },

            },
            {
              path: "/chukuNew",
              title: "出库记录",
              code: "chuku",
              children: {
                add: {
                  title: "新建出库",
                  flag: true,
                  code: "add",
                },
                baofei: {
                  title: "报废出库",
                  flag: true,
                  code: "baofei",
                }
              },

            },
            {
              path: "/rukuNew",
              title: "入库记录",
              code: "ruku",
            },
          ],
        },

        {
          title: "产品中心",
          code: "chanpin",
          src: require("../assets/img/leftNav/chanpin.png"),
          children: [
            {
              path: "/chanpin",
              title: "商品",
              code: "goods",
              children: {
                add: {
                  title: "新建",
                  flag: true,
                  code: "add",
                },
                edit: {
                  title: "编辑",
                  flag: true,
                  code: "edit",
                },
                del: {
                  title: "删除",
                  flag: true,
                  code: "del",
                },
                sort: {
                  title: "分类管理",
                  flag: true,
                  code: "sort",
                },
              },
            },
            {
              path: "/medical",
              title: "药品",
              code: "medical",
              children: {
                add: {
                  title: "新建",
                  flag: true,
                  code: "add",
                },
                edit: {
                  title: "编辑",
                  flag: true,
                  code: "edit",
                },
                del: {
                  title: "删除",
                  flag: true,
                  code: "del",
                },
                sort: {
                  title: "分类管理",
                  flag: true,
                  code: "sort",
                },
              },
            },
            {
              path: "/group",
              title: "套餐",
              code: "group",
              children: {
                add: {
                  title: "新建",
                  flag: true,
                  code: "add",
                },
                edit: {
                  title: "编辑",
                  flag: true,
                  code: "edit",
                },
                del: {
                  title: "删除",
                  flag: true,
                  code: "del",
                },
                sort: {
                  title: "分类管理",
                  flag: true,
                  code: "sort",
                },
              },
            },
            {
              path: "/lifeservice",
              title: "生活服务",
              code: "lifeservice",
              children: {
                add: {
                  title: "新建",
                  flag: true,
                  code: "add",
                },
                edit: {
                  title: "编辑",
                  flag: true,
                  code: "edit",
                },
                del: {
                  title: "删除",
                  flag: true,
                  code: "del",
                },
                sort: {
                  title: "分类管理",
                  flag: true,
                  code: "sort",
                },
              },
            },
            {
              path: "/medicalservice",
              title: "医疗服务",
              code: "medicalservice",
              children: {
                add: {
                  title: "新建",
                  flag: true,
                  code: "add",
                },
                edit: {
                  title: "编辑",
                  flag: true,
                  code: "edit",
                },
                del: {
                  title: "删除",
                  flag: true,
                  code: "del",
                },
                sort: {
                  title: "分类管理",
                  flag: true,
                  code: "sort",
                },
              },
            },
            {
              path: "/livingbody",
              title: "活体",
              code: "livingbody",
              children: {
                add: {
                  title: "新建",
                  flag: true,
                  code: "add",
                },
                edit: {
                  title: "编辑",
                  flag: true,
                  code: "edit",
                },
                del: {
                  title: "删除",
                  flag: true,
                  code: "del",
                },
                sort: {
                  title: "分类管理",
                  flag: true,
                  code: "sort",
                },
              },
            },
            {
              path: "/fictitious",
              title: "虚拟道具",
              code: "fictitious",
              children: {
                add: {
                  title: "新建",
                  flag: true,
                  code: "add",
                },
                edit: {
                  title: "编辑",
                  flag: true,
                  code: "edit",
                },
                del: {
                  title: "删除",
                  flag: true,
                  code: "del",
                },
                sort: {
                  title: "分类管理",
                  flag: true,
                  code: "sort",
                },
                song: {
                  title: "赠送",
                  flag: true,
                  code: "song",
                },
              },
            },
            {
              path: "/consumables",
              title: "耗材",
              code: "consumables",
              children: {
                add: {
                  title: "新建",
                  flag: true,
                  code: "add",
                },
                edit: {
                  title: "编辑",
                  flag: true,
                  code: "edit",
                },
                del: {
                  title: "删除",
                  flag: true,
                  code: "del",
                },
                sort: {
                  title: "分类管理",
                  flag: true,
                  code: "sort",
                },
              },
            },
          ],
        },
        {
          title: "数据中心",
          code: "shuju",
          src: require("../assets/img/leftNav/shuju.png"),
          children: [
            {
              path: "/shuju",
              title: "门店数据",
              code: "mendianshuju",
              children: {
                shop: {
                  title: "切换门店",
                  flag: true,
                  code: "shop",
                },
              },
            },
            {
              path: "/caiwu",
              title: "财务数据",
              code: "caiwu",
            },
            {
              path: "/moneypk",
              title: "业绩PK",
              code: "moneypk",
              children: {
                edit: {
                  title: "设置数据",
                  flag: true,
                  code: "edit",
                },
              },
            },
            {
              path: "/Newmoneypk",
              title: "新业绩PK",
              code: "Newmoneypk",
              children: {
                Newmoneypk: {
                  title: "业绩PK",
                  flag: true,
                  code: "Newmoneypk",
                },
                staffshuju: {
                  title: "员工提成",
                  flag: true,
                  code: "staffshuju",
                },
                shopEdit: {
                  title: "设置门店数据",
                  flag: true,
                  code: "shopEdit",
                },
                Staffswitch: {
                  title: "员工提成切换",
                  flag: true,
                  code: "Staffswitch",
                },
                royalty: {
                  title: "设置员工提成比例",
                  flag: true,
                  code: "royalty",
                },
                seal: {
                  title: "数据封存",
                  flag: true,
                  code: "seal",
                },
              },
            },
            {
              path: "/staffshuju",
              title: "员工提成",
              code: "staffshuju",
              children: {
                staff: {
                  title: "切换员工",
                  flag: true,
                  code: "staff",
                },
              },
            },
            {
              path: "/huotishuju",
              title: "活体统计",
              code: "huotishuju",
            },
            {
              path: "/goodshuju",
              title: "商品统计",
              code: "goodshuju",
            },
          ],
        },
        {
          title: "商城管理",
          path: "/mall",
          code: "mall",
          src: require("../assets/img/leftNav/yiliao.png"),
          children: {
            goodList: {
              title: "商品列表",
              flag: true,
              code: "goodList",
            },
            huashengList: {
              title: "花生甄选列表",
              flag: true,
              code: "huashengList",
            },
            selectList: {
              title: "甄选上新列表",
              flag: true,
              code: "selectList",
            },
            up: {
              title: "上架",
              flag: true,
              code: "up",
            },
            down: {
              title: "下架",
              flag: true,
              code: "down",
            },
            edit: {
              title: "编辑",
              flag: true,
              code: "edit",
            },
          },
        },
        {
          title: "签章合同",
          code: "file",
          src: require("../assets/img/leftNav/qianzhang.png"),
          children: [
            {
              path: "/file",
              title: "全部合同",
              code: "fileList",
              children: {
                shop: {
                  title: "筛选门店",
                  flag: true,
                  code: "shop",
                },
              },
            },
            {
              path: "/fileStatistics",
              title: "合同统计",
              code: "fileStatistics",
            },
          ],
        },
        {
          title: "消息中心",
          code: "msg",
          src: require("../assets/img/leftNav/qianzhang.png"),
          children: [
            {
              path: "/dingding",
              title: "钉钉配置",
              code: "dingding",
              children: {
                edit: {
                  title: "钉钉配置",
                  flag: true,
                  code: "edit",
                },
                list: {
                  title: "钉钉模版",
                  flag: true,
                  code: "list",
                },
              },
            },
          ],
        },
      ],
    };
  },

  mounted() {
    const that = this;
    let url = encodeURIComponent("http://" + this.host);
    // 初始化
    let agentid = ''
    if (this.host == 'o2o.hscwhn.com') {
      agentid = "1000004"
    } else {
      agentid = "1000005"
    }
    console.log(this.$refs.wx_qrcode, "wx_qrcodewx_qrcode");
    const wwLogin = ww.createWWLoginPanel({
      el: this.$refs.wx_qrcode,
      params: {
        login_type: "CorpApp",
        appid: "ww8833d175b32ca6b0",
        agentid: agentid,
        redirect_uri: encodeURI("http://" + this.host),
        state: "loginState",
        redirect_type: "top",
      },
      onCheckWeComLogin({ isWeComLogin }) {
        console.log(isWeComLogin);
      },
      onLoginSuccess({ code }) {
        console.log({ code });
      },
      onLoginFail(err) {
        console.log(err, "123");
      },
    });
    //   window.location.href =
    //           "https://login.work.weixin.qq.com/wwlogin/sso/login/?appid='ww8833d175b32ca6b0'"+'&redirect_uri='+url+"&login_type=CorpApp&agentid=1000004&state=STATE";

    // 卸载
    // wwLogin.unmount();

    // //   console.log(this.host, this.$route.query,"cccccc")
    //   var handleMessage = (event) => {
    //     console.log(event,"event.origin")
    //     sessionStorage.clear();
    //     if (event.origin == "https://work.weixin.qq.com/") {
    //       //判断是否来自ddLogin扫码事件。
    //       var loginTmpCode = event.data;
    //       //获取到loginTmpCode后就可以在这里构造跳转链接进行跳转了
    //       alert("loginTmpCode"+loginTmpCode);
    //       window.location.href =
    //         "https://login.work.weixin.qq.com/wwlogin/sso/login?appid==" +
    //         this.appid+
    //         "&login_type=CorpApp&agentid=1000004&state=STATE&redirect_uri=REDIRECT_URI&loginTmpCode=" +
    //         loginTmpCode;
    //     }
    //   };
    //   if (typeof window.addEventListener != "undefined") {
    //     window.addEventListener("message", handleMessage, false);
    //   } else if (typeof window.attachEvent != "undefined") {
    //     window.attachEvent("onmessage", handleMessage);
    //   }
    //   var url = encodeURIComponent("http://" + this.host);
    //   var goto = encodeURIComponent(
    //     "https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=" +
    //     this.appId +
    //     "&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=" +
    //     url
    //   );
    //   window.DDLogin({
    //     id: "login_container",
    //     goto: goto, //请参考注释里的方式
    //     style: "border:none;background-color:#FFFFFF;padding:none;",
    //     width: "280",
    //     height: "300",
    //   });
    //   // window.addEventListener('keydown',e=>{
    //   // 	if(e.keyCode == 13){
    //   // 		this.submit()
    //   // 	}
    //   // })
    var code = this.queryString("code");
    console.log(code, this.$store.state.userInfo, 'code');
    if (
      !this.$public.isNull(code) &&
      this.$public.isNull(this.$store.state.userInfo.uId)
    ) {
      this.$http
        .get(
          process.env.VUE_APP_Url_8000 +
          "/api/Login/qywx?code=" +
          code
        )
        .then((res) => {
          if (res.code === 0) {
            console.log("登录后返回的", res);
            res.data.shops = res.data.shopInfos;
            if (res.code === 0) {
              this.$http.get(process.env.VUE_APP_zichan + "/api/SystemRights/staff/rightsTree", {
                systemCode: "o2o",
                staffId: res.data.staffId,
              })
                .then((res) => {
                  if (res.code == 0) {
                    if (res.data.length == 0) {
                      this.$message({
                        message: '没有登录系统查看的权限',
                        type: 'error'
                      });
                      return
                    } else {
                      const info = res.data[0].rights_info;
                      //循环对比 返回的路由结构  如果没有就删除已写的静态路由结构
                      for (let menuIndex = 0; menuIndex < this.menuListRoute.length; menuIndex++) {
                        const menuList = this.menuListRoute[menuIndex];
                        const infoIndex = info.findIndex(
                          (infoItem) => menuList.code == infoItem.code
                        );
                        if (infoIndex == -1) {
                          this.menuListRoute.splice(menuIndex, 1);
                          menuIndex--;
                          continue
                        }
                        //判断有二级菜单的进入
                        if (infoIndex != -1 && info[infoIndex].menu_type == 1 && menuList.children) {
                          for (
                            let menuListchid2Index = 0;
                            menuListchid2Index < menuList.children.length;
                            menuListchid2Index++
                          ) {
                            const menuListchid2 = menuList.children[menuListchid2Index];

                            const infoIndex2 = info[infoIndex].childs.findIndex((infoChilds2) => {
                              const childrenCode = menuList.code + "-" + menuListchid2.code;
                              return childrenCode == infoChilds2.code;
                            });
                            if (infoIndex2 == -1) {
                              this.menuListRoute[menuIndex].children.splice(menuListchid2Index, 1);
                              menuListchid2Index--;

                            } else {
                              //判断必须childs不为空 并且写死的路由不为空才进入 否则就直接把这个菜单为空
                              if (info[infoIndex].childs[infoIndex2].childs && JSON.stringify(menuListchid2.children) != "{}") {

                                const Obj = {}
                                for (const key in menuListchid2.children) {
                                  const code = menuList.code + "-" + menuListchid2.code + "-" + menuListchid2.children[key].code
                                  const infoChildBtn = info[infoIndex].childs[infoIndex2].childs
                                  const infoIndexBtn = infoChildBtn.findIndex(infoChildBtn => code == infoChildBtn.code)
                                  if (infoIndexBtn != -1) {
                                    Obj[key] = menuListchid2.children[key]
                                  }
                                }
                                menuListchid2.children = Obj
                              } else {
                                menuListchid2.children && !info[infoIndex].childs ? menuListchid2.children = {} : ''
                              }
                            }

                          }
                        } else if (menuList.children && JSON.stringify(menuList.children) != "{}") {
                          //没有二级菜单的直接进入btn按钮权限判断对比
                          const Obj = {}
                          for (const key in menuList.children) {
                            const code = menuList.code + "-" + menuList.children[key].code
                            const infoIndexBtn = info[infoIndex].childs.findIndex(infoChilds2 => code == infoChilds2.code)

                            if (infoIndexBtn != -1) {
                              Obj[key] = menuList.children[key]
                            }

                          }
                          menuList.children = Obj
                        }
                      }
                      sessionStorage.setItem('menuListRoute', JSON.stringify(this.menuListRoute))
                      console.log(this.menuListRoute, "???????");
                      if (this.menuListRoute[0].path) {
                        let path1 = this.menuListRoute[0].path
                        this.$router.replace({ path: path1 });
                      } else {
                        let path1 = this.menuListRoute[0].children[0].path
                        this.$router.replace({ path: path1 });
                      }
                    }
                  }
                });
            }
            this.$store.commit("setUserInfo", res.data);
            this.$store.commit("setShopId", res.data.ownShopId); // 默认所属门店
            this.$store.commit("set_myShopList", res.data.systemShopInfos); // 所属门店列表  切换门店用到
            this.$store.commit("setIp", sessionStorage.getItem("ip"));
            sessionStorage.setItem("systemId", "5ed3645a8304352984588f1a");
            this.$store.dispatch("getMsg_unread_num_obj");

            // this.$router.replace({ path: "/mendian/shouyin" });
          }
        });
    }
  },
  methods: {
    async submit() {
      if (this.$public.isNull(this.user)) {
        this.$message({
          message: "请输入用户名",
          type: "error",
        });
        return;
      } else if (this.$public.isNull(this.pwd)) {
        this.$message({
          message: "请输入密码",
          type: "error",
        });
        return;
      }
      let params = {
        userName: this.user,
        userPwd: Base64.encode(this.pwd),
      };
      this.$http
        .post(process.env.VUE_APP_Url_8000 + "/api/Login/app", params)
        .then(async (res) => {
          if (res.code == 0) {
            this.$store.commit("setUserInfo", res.data);
            this.$store.commit("setShopId", res.data.ownShopId); // 默认所属门店
            this.$store.commit("set_myShopList", res.data.systemShopInfos); // 所属门店列表  切换门店用到
            this.$store.commit("setIp", sessionStorage.getItem("ip"));
            sessionStorage.setItem("systemId", "5ed3645a8304352984588f1a");
            this.$store.dispatch("getMsg_unread_num_obj");
          }
          if (res.code === 0) {
            res.data.shops = res.data.shopInfos;
            await this.$http
              .get(
                process.env.VUE_APP_zichan +
                "/api/SystemRights/staff/rightsTree",
                {
                  systemCode: "o2o",
                  staffId: res.data.staffId,
                }
              )
              .then((res) => {
                if (res.code == 0) {
                  if (res.data.length == 0) {
                    this.$message({
                      message: "没有登录系统查看的权限",
                      type: "error",
                    });
                    return;
                  } else {
                    const info = res.data[0].rights_info;
                    //循环对比 返回的路由结构  如果没有就删除已写的静态路由结构
                    for (
                      let menuIndex = 0;
                      menuIndex < this.menuListRoute.length;
                      menuIndex++
                    ) {
                      const menuList = this.menuListRoute[menuIndex];
                      const infoIndex = info.findIndex(
                        (infoItem) => menuList.code == infoItem.code
                      );
                      if (infoIndex == -1) {
                        this.menuListRoute.splice(menuIndex, 1);
                        menuIndex--;
                        continue;
                      }
                      //判断有二级菜单的进入
                      if (
                        infoIndex != -1 &&
                        info[infoIndex].menu_type == 1 &&
                        menuList.children
                      ) {
                        for (
                          let menuListchid2Index = 0;
                          menuListchid2Index < menuList.children.length;
                          menuListchid2Index++
                        ) {
                          const menuListchid2 =
                            menuList.children[menuListchid2Index];

                          const infoIndex2 = info[infoIndex].childs.findIndex(
                            (infoChilds2) => {
                              const childrenCode =
                                menuList.code + "-" + menuListchid2.code;
                              return childrenCode == infoChilds2.code;
                            }
                          );
                          if (infoIndex2 == -1) {
                            this.menuListRoute[menuIndex].children.splice(
                              menuListchid2Index,
                              1
                            );
                            menuListchid2Index--;
                          } else {
                            //判断必须childs不为空 并且写死的路由不为空才进入 否则就直接把这个菜单为空
                            if (
                              info[infoIndex].childs[infoIndex2].childs &&
                              JSON.stringify(menuListchid2.children) != "{}"
                            ) {
                              const Obj = {};
                              for (const key in menuListchid2.children) {
                                const code =
                                  menuList.code +
                                  "-" +
                                  menuListchid2.code +
                                  "-" +
                                  menuListchid2.children[key].code;
                                const infoChildBtn =
                                  info[infoIndex].childs[infoIndex2].childs;
                                const infoIndexBtn = infoChildBtn.findIndex(
                                  (infoChildBtn) => code == infoChildBtn.code
                                );
                                if (infoIndexBtn != -1) {
                                  Obj[key] = menuListchid2.children[key];
                                }
                              }
                              menuListchid2.children = Obj;
                            } else {
                              menuListchid2.children && !info[infoIndex].childs
                                ? (menuListchid2.children = {})
                                : "";
                            }
                          }
                        }
                      } else if (
                        menuList.children &&
                        JSON.stringify(menuList.children) != "{}"
                      ) {
                        //没有二级菜单的直接进入btn按钮权限判断对比
                        const Obj = {};
                        for (const key in menuList.children) {
                          const code =
                            menuList.code + "-" + menuList.children[key].code;
                          const infoIndexBtn = info[infoIndex].childs.findIndex(
                            (infoChilds2) => code == infoChilds2.code
                          );

                          if (infoIndexBtn != -1) {
                            Obj[key] = menuList.children[key];
                          }
                        }
                        menuList.children = Obj;
                      }
                    }
                    sessionStorage.setItem(
                      "menuListRoute",
                      JSON.stringify(this.menuListRoute)
                    );
                    console.log(this.menuListRoute, "???????");
                    if (this.menuListRoute[0].path) {
                      let path1 = this.menuListRoute[0].path;
                      this.$router.replace({ path: path1 });
                    } else {
                      let path1 = this.menuListRoute[0].children[0].path;
                      this.$router.replace({ path: path1 });
                    }
                  }
                }
              });
          }
        });
    },
    queryString(qs) {
      let s = location.href;
      console.log(location.href, 'location.href');
      s = s.replace("?", "?&").split("&");
      let re = "";
      for (let i = 1; i < s.length; i++) {
        if (s[i].indexOf(qs + "=") == 0) {
          re = s[i].replace(qs + "=", "");
        }
      }
      return re;
    },
    isMobile() {
      var userAgentInfo = navigator.userAgent;
      var mobileAgents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod",
      ];
      var mobile_flag = false;
      //根据userAgent判断是否是手机
      for (var v = 0; v < mobileAgents.length; v++) {
        if (userAgentInfo.indexOf(mobileAgents[v]) > 0) {
          mobile_flag = true;
          break;
        }
      }
      var screen_width = window.screen.width;
      var screen_height = window.screen.height;
      //根据屏幕分辨率判断是否是手机
      if (screen_width < 500 && screen_height < 800) {
        mobile_flag = true;
      }
      return mobile_flag;
    },
  },
};
</script>
<style scoped lang="scss">
.wrapper {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: url("../assets/img/logBc.jpg") no-repeat;
  background-size: cover;
}

.qrcode {
  width: 500px;
  height: 500px;
  // background-color: #fff;
  z-index: 9999;
}

.wrapper .con {
  margin-top: -15%;
  background-color: #ffffff;
  padding: 30px 20px;
  border-radius: 6px;
}

.wrapper .con .item {
  margin-bottom: 20px;
}

.wrapper .con .title {
  text-align: center;
  font-size: 18px;
}

.wrapper .con .item .label {
  text-align: right;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  padding: 0 12px 0 0;
  box-sizing: border-box;
  width: 80px;
}

.wrapper .con .item .input_content {
  position: relative;
  font-size: 14px;
}

.wrapper .con .item .input_content img {
  position: absolute;
  top: 10px;
  left: 5px;
}

.wrapper .con .item .input {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  height: 40px;
  line-height: 40px;
  outline: none;
  padding: 0 15px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 280px;
  padding-left: 25px;
}

.wrapper .con .item .button {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  /* background: #fff; */
  /* border: 1px solid #dcdfe6; */
  /* color: #606266; */
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  outline: none;
  margin: 0;
  transition: 0.1s;
  font-weight: 500;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  padding: 12px 20px;
  font-size: 14px;
  border-radius: 4px;
  width: 100%;
}

.wrapper .con .item .button:active {
  background: #66b1ff;
  border-color: #66b1ff;
  color: #fff;
}

.wrapper .con .btn {
  text-align: center;
  width: 100%;
}

.tip {
  color: red;
  margin-left: 25px;
}

::v-deep .el-tabs__nav-wrap {
  display: none !important;
}

::v-deep .el-tabs__nav-wrap::after {

  display: none !important;
}
</style>